import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import { formatMoney, STORE } from "../config/store";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, quantity, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const nextImage = () => {
    if (product.images && product.images.length > 0) {
      setSelectedImage((prev) => (prev + 1) % product.images.length);
    }
  };

  const prevImage = () => {
    if (product.images && product.images.length > 0) {
      setSelectedImage((prev) =>
        prev === 0 ? product.images.length - 1 : prev - 1
      );
    }
  };

  const currentImage = product.images?.[selectedImage] || product.image;
  const isAvailable = product.inventory > 0;

  return (
    <div className="product-detail-container">
      <div className="breadcrumbs">
        <Link to="/">HOME</Link> / <span>{product.name.toUpperCase()}</span>
      </div>
      
      <div className="product-detail-content">
        <div className="product-image-section">
          <div className="image-container">
            {product.compareAtPrice ? (
              <span className="badge sale">SALE</span>
            ) : !isAvailable ? (
              <span className="badge sold-out">SOLD OUT</span>
            ) : null}
            <button aria-label="Previous product image" className="nav-btn prev" onClick={prevImage}>&#8592;</button>
            <img src={currentImage} alt={product.name} className="main-image" />
            <button aria-label="Next product image" className="nav-btn next" onClick={nextImage}>&#8594;</button>
          </div>
        </div>

        <div className="product-info-section">
          <h1 className="title">{product.name}</h1>
          <p className="category">{product.category?.toUpperCase()}</p>
          
          <div className="price-container">
            <div className="prices">
              {product.compareAtPrice && <span className="original-price">{formatMoney(product.compareAtPrice)}</span>}
              <span className="sale-price">{formatMoney(product.price)}</span>
            </div>
            {product.compareAtPrice && <span className="sale-tag">SALE</span>}
          </div>
          
          

          {product.size && product.size.length > 1 && (
            <div className="variant-section">
              <label>Size</label>
              <div className="variant-options">
                {product.size.map((s) => (
                  <button
                    key={s}
                    className={`variant-btn ${selectedSize === s ? "active" : ""}`}
                    onClick={() => setSelectedSize(s)}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </div>
          )}

          {product.colors && product.colors.length > 0 && (
            <div className="variant-section">
              <label>Color</label>
              <div className="variant-options">
                {product.colors.map((c) => (
                  <button
                    key={c}
                    className={`variant-btn ${selectedColor === c ? "active" : ""}`}
                    onClick={() => setSelectedColor(c)}
                  >
                    {c}
                  </button>
                ))}
              </div>
            </div>
          )}

          <div className="action-section">
            <div className="quantity-selector">
              <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>-</button>
              <span>{quantity}</span>
              <button onClick={() => setQuantity(Math.min(product.inventory, quantity + 1))}>+</button>
            </div>
            <button 
              className="add-to-cart-btn" 
              onClick={handleAddToCart}
              disabled={!isAvailable}
            >
              {isAvailable ? "ADD TO CART" : "SOLD OUT"}
            </button>
          </div>
          
           

          <div className="shipping-info">
            <p>Ships from our online store with a fixed <strong>{formatMoney(STORE.shippingFee)}</strong> order shipping charge.</p>
            <p className="ready-time">Delivery timing is confirmed only when available for the order.</p>
          </div>

          <div className="status-list">
            <div className="status-item">
              <span className="icon">&#9202;</span> {isAvailable ? `${product.inventory} currently recorded in stock.` : "Currently unavailable."}
            </div>
            <div className="status-item">
              <span className="icon">&#10003;</span> Prices and payment are in {STORE.currency}.
            </div>
            <div className="status-item">
              <span className="icon">&#10003;</span> Card details are entered on hosted checkout.
            </div>
          </div>

          <div className="description-section">
            <h3>Description</h3>
            {product.description && product.description.map((desc, idx) => (
              <p key={idx}>{desc}</p>
            ))}
            {product.details && (
              <dl className="product-facts">
                {product.details.map((detail) => (
                  <div key={detail.label}>
                    <dt>{detail.label}</dt>
                    <dd>{detail.value}</dd>
                  </div>
                ))}
              </dl>
            )}
            
            {product.Features && (
              <ul className="features-list">
                {product.Features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
